export default __webpack_public_path__ + "static/media/warning-banner-icon.4e830659.svg";